import createIcon from '../../createIcon';

/**
 * @component @name SyncAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTJMMjIgOEwxOCA0VjdIM1Y5SDE4VjEyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTYgMTJMMiAxNkw2IDIwVjE3SDIxVjE1SDZWMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SyncAlt = createIcon('SyncAlt', [
  ['path', { d: 'M18 12L22 8L18 4V7H3V9H18V12Z', key: '1ok0c3' }],
  ['path', { d: 'M6 12L2 16L6 20V17H21V15H6V12Z', key: 'fewiv9' }],
]);

export default SyncAlt;
